import { combineReducers } from '@reduxjs/toolkit';

/**
 * Reducers within Amwell Reducer
 */
import { consumerReducer, ConsumerState } from './consumer/reducers';
import { activeConsumerReducer, ActiveConsumerState } from './activeConsumer/reducers';
import { visitContextReducer, VisitContextState } from './visitContext/reducers';
import { visitReducer, VisitState } from './visit/reducers';
import { storageReducer, StorageState } from './storage/reducers';
import { systemReducer, SystemState } from './system/reducers';
import { appointmentsReducer, AppointmentsState } from './appointments/reducers';
import { activityReducer, ActivityState } from './activity/reducers';
import { testMyDeviceReducer, TestMyDeviceState } from './testMyDevice/reducers';

export interface AmwellState {
  storage: StorageState;
  consumer: ConsumerState;
  activeConsumer: ActiveConsumerState;
  visitContext: VisitContextState;
  visit: VisitState;
  appointments: AppointmentsState;
  activity: ActivityState;
  system: SystemState;
  testMyDevice: TestMyDeviceState;
}

export default combineReducers({
  storage: storageReducer,
  consumer: consumerReducer,
  activeConsumer: activeConsumerReducer,
  visitContext: visitContextReducer,
  visit: visitReducer,
  appointments: appointmentsReducer,
  activity: activityReducer,
  system: systemReducer,
  testMyDevice: testMyDeviceReducer
});
